import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

const ContactInfoCard = ({ title, value, helper }) => (
  <Card
    sx={{
      height: "100%",
      border: "1px solid var(--color-border)",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
      transition: "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "var(--shadow-soft)",
        borderColor: "rgba(183, 132, 69, 0.22)",
      },
    }}
  >
    <CardContent sx={{ p: { xs: 2.85, md: 3.2 } }}>
      <Box
        sx={{
          width: 44,
          height: 4,
          borderRadius: 999,
          bgcolor: "primary.main",
          mb: 2.05,
        }}
      />
      <Typography variant="overline" sx={{ color: "primary.main" }}>
        {title}
      </Typography>
      <Typography variant="h6" sx={{ mt: 1.35, mb: 1.1, maxWidth: "20ch" }}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {helper}
      </Typography>
    </CardContent>
  </Card>
);

export default ContactInfoCard;
